import {
  isMessengerFullyConfigured,
  isMessengerProjectConfigured,
} from "~/lib/channels/messenger-platform-credentials";

/** Set false when platform Meta app + webhook are deployed (MESSENGER_* env vars). */
export const MESSENGER_CHANNEL_COMING_SOON = false;

export function isMessengerChannelLive(
  channels?: { messenger?: boolean } | null | undefined,
): boolean {
  if (MESSENGER_CHANNEL_COMING_SOON) return false;
  return channels?.messenger === true;
}

/** Server-side: platform env + project page credentials. */
export function isMessengerConfigured(
  visualSettings?: {
    messengerPageId?: string | null;
    messengerPageAccessToken?: string | null;
  } | null,
): boolean {
  return isMessengerFullyConfigured(visualSettings);
}

export { isMessengerProjectConfigured };

/** Saved project credentials + platform Meta app env vars (and not in coming-soon mode). */
export function canEnableMessengerChannel(options: {
  platformConfigured: boolean;
  visualSettings?: {
    messengerPageId?: string | null;
    messengerPageAccessToken?: string | null;
  } | null;
}): boolean {
  if (MESSENGER_CHANNEL_COMING_SOON) return false;
  return options.platformConfigured && isMessengerProjectConfigured(options.visualSettings);
}
